// Copy-Logik entfernt: Klick auf den Rabattcode-Button aktiviert jetzt den Code
// (gleiche Logik wie die Rabatt-Bar oben, via bd-coupon.js / js-discount-appliable-wrapper),
// statt ihn in die Zwischenablage zu kopieren.

// pdp sale timer code starts
window.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("product-timer").forEach((el) => {
    const endDateStr = el.getAttribute("data-enddate");
    const code = el.getAttribute("data-code");

    const parseDate = (str) => {
      if (!str) return null;
      const [date, time] = str.split(" ");
      const [day, month, year] = date.split("/");
      const [hours, minutes] = time.split(":");

      return new Date(year, month - 1, day, hours, minutes);
    };

    const end = parseDate(endDateStr);
    if (!end || end <= new Date()) return;

    const timerEl = el.querySelector(".countdown__timer");

    // 👉 get individual elements
    const daysEl = el.querySelector("[data-days]");
    const hoursEl = el.querySelector("[data-hours]");
    const minutesEl = el.querySelector("[data-minutes]");
    const secondsEl = el.querySelector("[data-seconds]");

    if (timerEl && daysEl && hoursEl && minutesEl && secondsEl) {
      let interval;

      const updateTimer = () => {
        const now = new Date();
        const diff = end - now;

        if (diff <= 0) {
          daysEl.textContent = "00";
          hoursEl.textContent = "00";
          minutesEl.textContent = "00";
          secondsEl.textContent = "00";
          clearInterval(interval);
          return;
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor(diff / (1000 * 60 * 60)) % 24;
        const minutes = Math.floor(diff / (1000 * 60)) % 60;
        const seconds = Math.floor(diff / 1000) % 60;

        // 👉 update individual spans
        daysEl.textContent = String(days).padStart(2, "0");
        hoursEl.textContent = String(hours).padStart(2, "0");
        minutesEl.textContent = String(minutes).padStart(2, "0");
        secondsEl.textContent = String(seconds).padStart(2, "0");
      };

      updateTimer();
      interval = setInterval(updateTimer, 1000);
    }

    // ===== your existing copy logic (unchanged) =====
    const actionBtn = el.querySelector(".countdown__btn--action");
    const checkBtn = el.querySelector(".countdown__btn--check");

    if (!actionBtn || !checkBtn || !code) return;

    const copyCode = async () => {
      try {
        await navigator.clipboard.writeText(code);

        actionBtn.classList.add("tw-hidden");
        actionBtn.classList.remove("tw-flex");

        checkBtn.classList.add("tw-flex");
        checkBtn.classList.remove("tw-hidden");

        setTimeout(() => {
          checkBtn.classList.add("tw-hidden");
          checkBtn.classList.remove("tw-flex");

          actionBtn.classList.remove("tw-hidden");
          actionBtn.classList.add("tw-flex");
        }, 1500);
      } catch (err) {
        console.error("Clipboard error:", err);
      }
    };

    actionBtn.addEventListener("click", copyCode);
  });

  // wrap pdp accordions in wrapper
  const items = document.querySelectorAll(".product_collapse");

  if (!items.length) return;
  const wrapper = document.createElement("div");
  wrapper.className = "collapsible-tabs-wrapper";
  const firstItem = items[0];
  firstItem.parentNode.insertBefore(wrapper, firstItem);
  items.forEach((item) => wrapper.appendChild(item));
});
//   ends

// ends //
